import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface reportState {
	isLoading: boolean;
	reportList: any;
	totalReport: number;
	downloadData: any;
}

const initialState: reportState = {
	isLoading: false,
	reportList: [],
	totalReport: 0,
	downloadData: []
};

const reportSlice = createSlice({
	name: 'ReportSlice',
	initialState,
	reducers: {
		getAllreportListInIt: state => {
			state.isLoading = true;
			state.reportList = [];
			state.totalReport = 0;
		},
		getAllreportListSuccess: (state, action: PayloadAction<any>) => {
			const data = action.payload.data;
			// console.log(action.payload);
			const activeTab = action.payload.activeTab;

			state.isLoading = false;
			state.totalReport = data.count;
			activeTab === 'Driver' && (state.reportList = [...data.drivers]);
			activeTab === 'Order' && (state.reportList = [...data.result]);
			activeTab === 'Customer' && (state.reportList = [...data.customers]);
			activeTab === 'Repeat_Order' && (state.reportList = [...data.result]);
			activeTab === 'Leakage_Delays' && (state.reportList = [...data.result]);
			activeTab === 'Vendor' && (state.reportList = [...data.vendors]);
			activeTab === 'Product' && (state.reportList = [...data.productList]);
			activeTab === 'Transaction' && (state.reportList = [...data.result]);
		},
		getAllreportListError: state => {
			state.isLoading = false;
			state.reportList = [];
			state.totalReport = 0;
		},
		downloadDataInit: state => {
			// state.isLoading = true;
		},
		downloadDataSuccess: (state, action: PayloadAction<any>) => {
			const data = action.payload.data;
			const activeTab = action.payload.activeTab;
			// state.isLoading = true;
			activeTab === 'Driver' && (state.downloadData = [...data.drivers]);
			activeTab === 'Order' && (state.downloadData = [...data.drivers]);

			activeTab === 'Customer' && (state.downloadData = [...data.customers]);
		},
		downloadDataError: state => {
			state.isLoading = false;
		}
	}
});

export const {
	getAllreportListError,
	getAllreportListInIt,
	getAllreportListSuccess,
	downloadDataError,
	downloadDataInit,
	downloadDataSuccess
} = reportSlice.actions;

export default reportSlice.reducer;
